import React from 'react';
import DocPage from '../../components/DocPage/DocPage';

function Careers() {
  return (
    <DocPage eyebrow="Careers" title="Careers at Orbix">
      <p className="doc-page__lead">
        We are building better systems for critical inspection work.
      </p>

      <p>
        Orbix brings together experienced NDE professionals, software engineers, and AI specialists who believe
        the industry can operate at a higher standard. We care about the details, take difficult problems
        seriously, and build technology that helps people do important work properly.
      </p>
      <p>
        We are always interested in hearing from people who want to contribute to that.
      </p>
      <p>
        Whether you are an NDE professional with ideas about how the industry can work better, or an engineer
        looking to take on complex technical problems alongside a highly capable team, we would like to hear
        from you.
      </p>

      <h2>Open roles</h2>
      <p>
        We do not have any open positions listed at the moment.
      </p>
      <p>
        That said, we are always open to meeting thoughtful, capable people who believe they could make a
        meaningful contribution to Orbix. Send your CV or a brief introduction to{' '}
        <a href="mailto:careers@orbixnde.com">careers@orbixnde.com</a>.
      </p>
    </DocPage>
  );
}

export default Careers;
